import styled from 'styled-components';

import AlertBox from 'components/ui/AlertBox';

export const StyledAlertBox = styled(AlertBox)`
  margin: 16px 0;
`;
